import { Settings } from 'lucide-react';

export const ConfigSettings = () => {
  return (
    <div data-testid="config-settings-page">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 uppercase tracking-tight">Config Settings</h1>
          <p className="text-slate-600 mt-1">Application configuration and preferences</p>
        </div>
      </div>
      <div className="bg-white rounded-sm border border-slate-200 flex flex-col items-center justify-center py-24">
        <Settings className="h-16 w-16 text-slate-300 mb-4" />
        <h2 className="text-2xl font-bold text-slate-700 mb-2">Coming Soon</h2>
        <p className="text-slate-500 text-sm">Configuration settings will be available in a future update.</p>
      </div>
    </div>
  );
};
